document.addEventListener('DOMContentLoaded', () => {
  setupModal();
});

function setupModal() {
  const button = document.getElementById('clickModal');
  const closeButton = document.getElementById('closeModal');
  const modalElement = document.getElementById('password-modal-element');

  if (button && closeButton && modalElement) {
    button.addEventListener('click', () => {
      modalElement.style.display = 'flex';
    });

    closeButton.addEventListener('click', () => {
      modalElement.style.display = 'none';
    });
  }
}

// Handle Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  setupModal();
});

document.addEventListener('shopify:section:unload', (event) => {
  const button = document.getElementById('clickModal');
  const closeButton = document.getElementById('closeModal');
  
  if (button) {
    button.removeEventListener('click', () => {});
  }
  
  if (closeButton) {
    closeButton.removeEventListener('click', () => {});
  }
});
